



















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';

import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import {Validation, validationMixin} from "vuelidate";
import {required, maxValue, minValue} from "vuelidate/lib/validators";

interface ILefEntry {
  text: string,
  loadEqFactor: number,
  pctTraffic: number,
  quickHelpText: string,
  quickHelpLink: string
}

@Component({
  components: {
    PxDropdown,
    PxNumberInput
  },
  mixins: [validationMixin],
  validations: {
    totalPct: {
      required,
      minValue: minValue(100),
      maxValue: maxValue(100)
    },
    loadEquivalencyFactor: {
      minValue: minValue(0),
    }
  }
})
export default class CalculateLefModal extends Vue {
  @Prop() scenario!: any;

  factors: ILefEntry[] = [

    {
      text: 'Passenger',
      loadEqFactor: 0.0001,
      pctTraffic: 40,
      quickHelpText: 'This category includes FHWA Class 1, 2, and 3 vehicles. Examples are motorcycles, passenger cars, pick-ups and vans.',
      quickHelpLink: "http://www.pavementinteractive.org/article/trucks-and-buses/"
    },
    {
      text: 'Single Units',
      loadEqFactor: 0.6,
      pctTraffic: 10,
      quickHelpText: 'This category includes FHWA Class 4, 5, 6, and 7 vehicles. Examples are buses (non-articulated), RVs, delivery trucks and garbage trucks.',
      quickHelpLink: "http://www.pavementinteractive.org/article/trucks-and-buses/"
    },
    {
      text: 'Double Units',
      loadEqFactor: 1.5,
      pctTraffic: 30,
      quickHelpText: 'This category includes FHWA Class 8, 9, and 10 vehicles. Examples are semi tractor-trailers with only one trailer.',
      quickHelpLink: "http://www.pavementinteractive.org/article/trucks-and-buses/"
    },
    {
      text: 'Trains',
      loadEqFactor: 2.63,
      pctTraffic: 10,
      quickHelpText: 'This category includes FHWA Class 12, 12, and 13 vehicles. Examples are semi tractor-trailers with more than one trailer.',
      quickHelpLink: "http://www.pavementinteractive.org/article/trucks-and-buses/"
    },
    {
      text: 'Other',
      loadEqFactor: 0,
      pctTraffic: 10,
      quickHelpText: 'This category can be a custom load factor provided by the user. It is recommended to only be used if you have a defined compsite factor you use within your agency.',
      quickHelpLink: "http://www.pavementinteractive.org/article/loads/"
    },
  ];

  get totalPct() {
    return this.factors.map(f => f.pctTraffic).reduce((a: number, b: number): number => Number(a) + Number(b), 0);
  }


  get loadEquivalencyFactor() {
    return this.factors.map(f => f.loadEqFactor * f.pctTraffic/100).reduce((a: number, b: number): number => Number(a) + Number(b), 0)
  }

  setLoadEquivalencyFactor() {
    console.log("Saving traffic");
    this.scenario.loadEquivalencyFactor = Number(this.loadEquivalencyFactor.toFixed(5));
    this.$emit('save');
    this.$emit('ok');
  }

  get okDisabled(){
    return this.$v.$invalid
  }
}
